import { render, staticRenderFns } from "./deficiencySuccess.vue?vue&type=template&id=d80d314c&scoped=true&"
import script from "./deficiencySuccess.vue?vue&type=script&lang=js&"
export * from "./deficiencySuccess.vue?vue&type=script&lang=js&"
import style0 from "./deficiencySuccess.vue?vue&type=style&index=0&id=d80d314c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d314c",
  null
  
)

export default component.exports